const MIN_PHONE_LENGTH_TO_MASK = 5;
const VISIBLE_PHONE_DIGITS = 4;

type EmailOrSms = 'email' | 'sms';

export function maskContact(value: string, channel: EmailOrSms): string {
	if (channel === 'sms') {
		return maskPhone(value);
	}
	return maskEmail(value);
}

function maskPhone(value: string): string {
	const hasPlus = value.startsWith('+');
	const digits = hasPlus ? value.slice(1) : value;
	if (digits.length < MIN_PHONE_LENGTH_TO_MASK) {
		return value;
	}
	const visible = digits.slice(-VISIBLE_PHONE_DIGITS);
	return `… ${visible}`;
}

function maskEmail(value: string): string {
	const atIndex = value.indexOf('@');
	if (atIndex <= 0) {
		return value;
	}
	const firstChar = value.charAt(0);
	const domain = value.slice(atIndex);
	return `${firstChar}***${domain}`;
}
